import { render, staticRenderFns } from "./DayOffClassDialog.vue?vue&type=template&id=0bdb670e&scoped=true"
import script from "./DayOffClassDialog.vue?vue&type=script&lang=js"
export * from "./DayOffClassDialog.vue?vue&type=script&lang=js"
import style0 from "./DayOffClassDialog.vue?vue&type=style&index=0&id=0bdb670e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdb670e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bdb670e')) {
      api.createRecord('0bdb670e', component.options)
    } else {
      api.reload('0bdb670e', component.options)
    }
    module.hot.accept("./DayOffClassDialog.vue?vue&type=template&id=0bdb670e&scoped=true", function () {
      api.rerender('0bdb670e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/DayOffClassDialog.vue"
export default component.exports